/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 12/23/2016
 * Time: 2:41 PM
 */

(function($) {
    $.widget('ca.caMiniCart', {
        options: {
            checkoutDuration: 0,
            checkoutTime: {},
            colorWarning: '#f39c12',
            colorExpired: '#e74c3c',
        },
        numberOfActiveCountDowns: 0,

        _create: function () {
            this._beginCheckoutDurationCountdown();
        },

        _beginCheckoutDurationCountdown: function () {
            var epsilon = 2;
            var checkoutTimeArray = this.options.checkoutTime,
                timeSinceLastItem = this.options.checkoutDuration * 60 - this.getTimeLeft();

            if (checkoutTimeArray.length > 0 && timeSinceLastItem <= epsilon
            ) {
                $.caAlert(
                    'Your class registration is guaranteed for the next ' + this.options.checkoutDuration + ' minutes. You may still register after this time but your spot is no longer guaranteed.',
                    '',
                    {
                        type: 'alert'
                    }
                );
            }

            this._startCountdown();

        },

        _startCountdown: function () {
            var checkoutTimeArray = this.options.checkoutTime;
            var firstCheckoutTime = checkoutTimeArray.min();
            if (firstCheckoutTime <= 0) {
                $('#reservation-countdown').css('color', this.options.colorWarning);
            }

            var self = this;
            for (var i = 0; i < checkoutTimeArray.length; i++) {
                if (checkoutTimeArray[i] > 0) {
                    var countdownHidden = $('<div id="countdown-' + i + '">');
                    $('#countdown-block').append(countdownHidden);
                    var endDate = new Date();
                    endDate.setSeconds(endDate.getSeconds() + parseInt(checkoutTimeArray[i]));
                    countdownHidden.countdown(endDate)
                        .on('finish.countdown', function() {
                            self.onCountDownFinish();
                        });
                    self.numberOfActiveCountDowns ++;
                }
            }

            var currentDate = new Date();
            endDate = new Date();
            var timeLeft = this.getTimeLeft();
            endDate.setSeconds(currentDate.getSeconds() + timeLeft);

            var countdown = $('div#countdown').countdown(endDate, function(event) {
                var totalHours = event.offset.totalDays * 24 + event.offset.hours;
                if (totalHours) {
                    totalHours += ':';
                } else {
                    totalHours = '';
                }
                $('#reservation-countdown').html(event.strftime(totalHours + '%M:%S'));
            });

            if (timeLeft > 0) {
                countdown.countdown('start');
            }
            if (this.numberOfActiveCountDowns <= 0) {
                $('#reservation-countdown').css('color', self.options.colorExpired);
            }
        },

        getTimeLeft: function() {
            var checkoutTimeArray = this.options.checkoutTime;
            var minTime = parseFloat(checkoutTimeArray.min());

            return minTime < 0 ? 0 : minTime;
        },
        
        onCountDownFinish: function () {
            $.post(
                '/member/update-persons-maximum'
            );

            this.numberOfActiveCountDowns --;
            var color = this.numberOfActiveCountDowns > 0
                ? this.options.colorWarning
                : this.options.colorExpired;

            $('#reservation-countdown').css('color', color);
        }

    });
})(jQuery);
